import React, { Component } from "react";
import { OrderedMap } from "immutable";
import { INPUT_TYPES } from "constants/index";
import PropTypes from "prop-types";
import { Form, Button, Icon} from "antd";
import {
    fieldGenerator,
} from "utilities/form";
import { CompanyService } from "../../../services";
import { STATE_STATUS } from "../../../constants";




class CompanyInvoicesAddForm extends Component { 
    state = {
        dealerStatus : STATE_STATUS.UNFETCHED,
    }   
    componentDidMount(){
        if(this.props.selectedSeller){
            this.props.form.setFieldsValue({
                "seller": this.props.selectedSeller
            });
        }
    }

    static getDerivedStateFromProps(props, state) {
        if (state.dealerStatus !== props.dealers.status) {
            return {
                dealerStatus: props.dealers.status
            };
        }
        return null;
    }
   
    onDealerSearch = (str) => {
        return CompanyService.getSellerList(str).then(({ data }) => ({
            data: this.formatData(data)
        }));
    }

    beforeUpload = (_) => {
        let files = [];
        const existingFiles = this.props.form.getFieldValue("invoice_files");
        if(existingFiles){
            files = [...existingFiles, _];
        }else {
            files.push(_);
        }
        this.props.form.setFieldsValue({
            "invoice_files": files
        });
        return false;
    }

    onRemove = _ => {
        let files = this.props.form.getFieldValue("invoice_files").filter(file => file.uid !== _.uid);
        this.props.form.setFieldsValue({
            "invoice_files": files
        });
    }
    formFields = new OrderedMap({
        seller: {
            type: INPUT_TYPES.OBJECT_SELECT,
            className: "form-field fb-100 w-100 mt-10",
            placeholder: "Select Distributor",
            showSearch: true,
            notFoundContent: "This Seller doesn't exist, you need to create it.",
            labelProp: "name",
            onSelect:(_) => this.onSelectSeller(_),
            onSearch: this.onDealerSearch,
            rules:[{
                required: true,
                message: "Please select a distributor"
            }]
        },
        invoice_files: {
            className: "form-field fb-100",
            title: "Select PDF files",
            subtitle: "or drop PDFs here",
            multiple: true,
            action: null,
            showUploadList: false,
            type: INPUT_TYPES.DRAGGABLEUPLOADER,
            beforeUpload:this.beforeUpload,
            onRemove:this.onRemove,
            accept: ".pdf, .jpg, .png, .xlsx, .xls"
        }
    });
    onSelectSeller = (distributor) =>{
        if(this.props.handleInvoiceForm){
            this.props.handleInvoiceForm(distributor);
        }
        this.props.getDealers && this.props.getDealers(distributor.gstin);
    }
    formatData = (data) => {
        if(data) {
            return data.map(_ => {
                return {
                    ..._,
                    name: `${_.name} - ${_.gst_state ? _.gst_state : ""} (${_.gstin})`
                };
            });
        }
        return data;
    }

    fieldGenerator = fieldGenerator.bind(this.props.form);

    onValuesSubmit = e => {
        e.preventDefault();
        if (!this.props.loading) {
            this.props.form.validateFields((err, data) => {
                if (!err) {
                    if(data.seller && data.invoice_files && data.invoice_files.length > 0){
                        if(this.props.handleInvoiceForm){
                            this.props.handleInvoiceForm({});
                        }
                        this.props.modalSubmit(data);
                    }
                }
            });
        }
    };

    render() {
        return (
            <Form onSubmit={this.onValuesSubmit}>
                <div className={"form-row align-items-center"}>
                    {this.formFields.map((field, fieldName) => this.fieldGenerator(
                        fieldName,
                        field,
                    )()
                    ).toList()}
                </div>
                <Form.Item className={"mb-10"}>
                    <Button className={"w-100"} type="primary" htmlType={"submit"} 
                        disabled={this.props.loading || [STATE_STATUS.FETCH_FAILED , STATE_STATUS.UNFETCHED].includes(this.state.dealerStatus)}>
                        {this.props.loading ? 
                            <Icon type={"loading"} /> 
                            : null
                        }
                        Upload
                    </Button>
                </Form.Item>
            </Form>
        );
    }
}

CompanyInvoicesAddForm.propTypes = {
    form: PropTypes.object,
    values: PropTypes.object,
    loading: PropTypes.bool,
    modalSubmit: PropTypes.func,
    getDealers : PropTypes.func,
    handleInvoiceForm : PropTypes.func,
    selectedSeller : PropTypes.func
};

export default Form.create({
    mapPropsToFields: ({ values }) =>
        values &&
        values
            .map((value) => {
                return Form.createFormField({
                    value
                });
            })
            .toJS()
})(CompanyInvoicesAddForm);